export const updateInvoiceMini = /* GraphQL */ `
  mutation UpdateInvoice(
    $input: UpdateInvoiceInput!
    $condition: ModelInvoiceConditionInput
  ) {
    updateInvoice(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateInvoiceServiceMini = /* GraphQL */ `
  mutation UpdateInvoiceService(
    $input: UpdateInvoiceServiceInput!
    $condition: ModelInvoiceServiceConditionInput
  ) {
    updateInvoiceService(input: $input, condition: $condition) {
      id
    }
  }
`;
